import type {ReactElement} from 'react';
import {usePrefersReducedMotion} from '@Hooks/usePrefersReducedMotion';
import {useIsPageSettled} from './utm-link-video-hooks';
import styles from './utm-link-video.module.scss';
import type {UtmLinkVideoProps} from './utm-link-video.types';
import {HEVC_WITH_ALPHA_SOURCE_TYPE, WEBM_SOURCE_TYPE} from './utm-link-video.types';

/**
 * The decorative demo beside the form: the skeleton's poster first, the video once the page has settled, the poster alone for reduced
 * motion. HEVC comes first because Safari plays its transparency and cannot play the WebM's.
 */
export function UtmLinkVideo({sources}: UtmLinkVideoProps): ReactElement {
  const prefersReducedMotion = usePrefersReducedMotion();
  const isPageSettled = useIsPageSettled();

  const renderMedia = (): ReactElement => {
    if (prefersReducedMotion || !isPageSettled) {
      return <img className={styles.utmLinkVideoMedia} src={sources.posterUrl} alt="" />;
    }
    return (
      <video className={styles.utmLinkVideoMedia} poster={sources.posterUrl} autoPlay loop muted playsInline>
        <source src={sources.hevcUrl} type={HEVC_WITH_ALPHA_SOURCE_TYPE} />
        <source src={sources.webmUrl} type={WEBM_SOURCE_TYPE} />
      </video>
    );
  };

  return (
    <div className={styles.utmLinkVideo} aria-hidden="true">
      {renderMedia()}
    </div>
  );
}
